import { RequestHelper,IResponse,IResponseWithData } from "../libs/request-helper";

export class InfiniteScrollHelper{

	private static isMaxItems = false;
	private static isLoading = false;
	private static mainContainer: HTMLElement;
	private static dataContainer: HTMLElement;
	private static responseCallback: (res: IResponse)=> boolean;
	private static requestDto:any;
	private static requestUrl:string

	public static init(mainContainer: HTMLElement, dataContainer: HTMLElement, responseCallback: (res: IResponse)=> boolean, requestDto:any, requestUrl:string){
		InfiniteScrollHelper.mainContainer = mainContainer;
		InfiniteScrollHelper.dataContainer = dataContainer;
		InfiniteScrollHelper.responseCallback = responseCallback;
		InfiniteScrollHelper.requestDto = requestDto;
		InfiniteScrollHelper.requestUrl = requestUrl;
		InfiniteScrollHelper.reInit(requestDto);
		window.addEventListener("scroll",() => InfiniteScrollHelper.onScroll());
	}

	public static reInit(requestDto:any){
		InfiniteScrollHelper.requestDto.lastEntrieId = undefined;
		InfiniteScrollHelper.isMaxItems = false;
		InfiniteScrollHelper.isLoading = false;
		InfiniteScrollHelper.requestDto = requestDto;
		InfiniteScrollHelper.clearContainer();
		InfiniteScrollHelper.loadData();
	}

	private static onScroll() {	
		if(InfiniteScrollHelper.shouldLoad()){
            var scrollPosition = window.scrollY;
            var dataContainerHeight = InfiniteScrollHelper.dataContainer.offsetHeight - window.innerHeight;
    		if(scrollPosition > dataContainerHeight) {
				InfiniteScrollHelper.loadData();
    		}
		}
	}

	private static shouldLoad():boolean{
		if(InfiniteScrollHelper.isMaxItems){
			return false;
		}
		if(InfiniteScrollHelper.isLoading){
			return false;
		}
		return true;
	}

	private static async loadData(){
		if(InfiniteScrollHelper.shouldLoad()){
			InfiniteScrollHelper.isLoading = true;
			var response = await RequestHelper.postJsonAndSpin(InfiniteScrollHelper.requestUrl, InfiniteScrollHelper.requestDto);
			InfiniteScrollHelper.isMaxItems = !InfiniteScrollHelper.responseCallback(response);
			InfiniteScrollHelper.isLoading = false;
			if(InfiniteScrollHelper.isListToShort()){
				InfiniteScrollHelper.loadData();
			}
		}
	}

	private static clearContainer(){
		InfiniteScrollHelper.dataContainer.innerHTML = "";
	}

	public static setRequestDto(requestDto: any){
		InfiniteScrollHelper.requestDto = requestDto;
	}

	private static isListToShort():boolean{
    	var docViewTop = window.pageYOffset;
    	var docViewBottom = docViewTop + window.innerHeight;
    	var elemTop = InfiniteScrollHelper.dataContainer.offsetTop;
    	var elemBottom = elemTop + InfiniteScrollHelper.dataContainer.offsetHeight;
		return (elemBottom <= docViewBottom);
	}
}